import routesMap from '@/routes/routeMap';

const country = process.env.VUE_APP_COUNTRY_ISO;

export default [
    { // Removing until after launch
        path: routesMap[country].jobs,
        name: 'jobs',
        components: {
            default: () => import(/* webpackChunkName: "jobs" */ '@/views/content/Jobs'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: routesMap[country].privacyPolicy,
        name: 'privacy-policy',
        components: {
            default: () => import(/* webpackChunkName: "privacy-policy" */ '@/views/content/PrivacyPolicy'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: routesMap[country].termsAndConditions,
        name: 'terms-and-conditions',
        components: {
            default: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/content/TermsAndConditions'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: routesMap[country].impressum,
        name: 'impressum',
        components: {
            default: () => import(/* webpackChunkName: "impressum" */ '@/views/content/Impressum'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: routesMap[country].paymentAndDelivery,
        name: 'payment-and-delivery',
        components: {
            default: () => import(/* webpackChunkName: "impressum" */ '@/views/content/PaymentAndDelivery'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
    {
        path: routesMap[country].rightToCancel,
        name: 'right-to-cancel',
        components: {
            default: () => import(/* webpackChunkName: "impressum" */ '@/views/content/RightToCancel'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
    },
];
